import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "@/redux/store";

export interface CallRequest {
  requestId: string;
  visitorId: string;
  companyId: string;
  type: "video" | "voice";
  message?: string | null;
  page?: string | null;
  preferredLanguage?: string | null;
  metadata?: Record<string, any> | null;
  visitor?: {
    id: string;
    sessionId?: string;
    currentUrl?: string | null;
    country?: string | null;
    city?: string | null;
    metadata?: Record<string, any> | null;
  } | null;
  requestedAt: string;
  // Room info for visitor-initiated calls (room created before rep accepts)
  roomUrl?: string;
  roomName?: string;
  callId?: string;
}

interface CallRequestState {
  requests: CallRequest[];
}

const initialState: CallRequestState = {
  requests: [],
};

const callRequestsSlice = createSlice({
  name: "callRequests",
  initialState,
  reducers: {
    addCallRequest: (state, action: PayloadAction<CallRequest>) => {
      const existingIndex = state.requests.findIndex(
        (req) => req.visitorId === action.payload.visitorId
      );

      if (existingIndex !== -1) {
        state.requests[existingIndex] = action.payload;
      } else {
        state.requests.unshift(action.payload);
      }
    },
    removeCallRequest: (state, action: PayloadAction<string>) => {
      state.requests = state.requests.filter((req) => req.visitorId !== action.payload);
    },
    clearCallRequests: (state) => {
      state.requests = [];
    },
  },
});

export const { addCallRequest, removeCallRequest, clearCallRequests } = callRequestsSlice.actions;

export const selectCallRequests = (state: RootState) => state.callRequests.requests;

export default callRequestsSlice.reducer;
